import { useEffect, useState } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../contexts/AuthContext';

// Shared by every page that renders SignatureForm (Signatures.jsx,
// UserDetailPopup.jsx) so the org's brand asset library (logos/icons/
// banners) is available to the "Marka Kütüphanesinden Ekle" picker —
// same shape as useOrganizationBrandColors.js, see that file for why the
// cancelled flag is a closure-local variable and not a ref.
export default function useOrganizationBrandAssets() {
  const { user } = useAuth();
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    if (!user?.organization) return;
    let cancelled = false;
    api.get(endpoints.signatures.brandAssets.list)
      .then(data => { if (!cancelled) setAssets(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelled) setAssets([]); });
    return () => { cancelled = true; };
  }, [user?.organization]);

  return [assets];
}
